<template>
  <PageContainer>
    <template #header>
      <PageHeader :title="$t('message.facebook.facebookAccounts')">
        <template #default>
          <ui-button
            v-if="showAddAccountButton"
            color="blueFb"
            @click="addAccount"
          >
            <FbIcon />
            <span class="ml-2">{{
              $t("message.facebook.loginWithFacebook")
            }}</span>
          </ui-button>
        </template>
      </PageHeader>
    </template>
    <div class="content">
      <Header />
      <AccountInfoBoxes />
      <AccountsContainer
        @accounts-loaded="onAccountsLoaded"
        :is-parent-loading="isLoading"
      />
    </div>
  </PageContainer>
</template>

<script>
import PageHeader from "@/components/ui/PageHeader.vue";
import PageContainer from "@/components/ui/PageContainer.vue";
import AccountInfoBoxes from "@/components/FacebookAccounts/AccountInfoBoxes.vue";
import Header from "@/components/FacebookAccounts/Header.vue";
import AccountsContainer from "@/components/FacebookAccounts/AccountsContainer.vue";
import facebookService from "@/services/facebook";
import mapIntegrationsService from "@/services/mapIntegrations.js";
import serviceHandler from "@/helpers/handlers/service";
import FbIcon from "@/components/ui/Icons/FbIcon.vue";

export default {
  name: "AccountsList",
  components: {
    PageHeader,
    PageContainer,
    AccountInfoBoxes,
    Header,
    AccountsContainer,
    FbIcon
  },
  data() {
    return {
      showAddAccountButton: false,
      isLoading: false
    };
  },
  methods: {
    onAccountsLoaded(accountsQuantity) {
      this.showAddAccountButton = accountsQuantity === 0;
    },
    addAccount() {
      window.location.href = this.facebookLoginUrl();
    },
    facebookLoginUrl() {
      const clientId = process.env.VUE_APP_FACEBOOK_APP_ID;
      const responseType = "code";
      const permissions = [
        "pages_show_list",
        "business_management",
        "pages_read_engagement",
        "public_profile",
        "email",
        "pages_manage_metadata"
      ];
      const redirectUri = window.location.origin + "/company/facebook-accounts";

      const url = new URL("https://www.facebook.com/v19.0/dialog/oauth");
      const params = new URLSearchParams({
        client_id: clientId,
        response_type: responseType,
        scope: permissions.join(","),
        redirect_uri: redirectUri
      });
      url.search = params.toString();

      return url.toString();
    }
  },
  mounted() {},

  watch: {
    "$route.query.code": {
      immediate: true,
      async handler(code) {
        if (code) {
          const queries = this.$route.query;
          delete queries.code;
          this.$router.replace({ query: queries });
          this.isLoading = true;
          await facebookService.addAccount(code);
          const facebookTogglePayload = {
            facebook: {
              is_enabled: true
            }
          };
          await serviceHandler(
            mapIntegrationsService.toggleMapIntegration(facebookTogglePayload)
          );

          await this.$refs.accountsContainer.fetchAccounts();
          this.isLoading = false;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  > * + * {
    margin-top: $spacing * 3;
  }
}
</style>
